const LOCAL_API_URL = "https://api.loadandlockcolorado.com/api";
const PRODUCTION_API_URL = "https://api.loadandlockcolorado.com/api";

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const isBrowser = typeof window !== "undefined";
const isLocalBrowser = isBrowser && ["localhost", "127.0.0.1"].includes(window.location.hostname);
const configuredApiUrl = process.env.GATSBY_API_URL;
const configuredApiUrlIsLocal =
  configuredApiUrl && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/.test(configuredApiUrl);
const configuredApiUrlIsInsecure = configuredApiUrl && configuredApiUrl.startsWith("http://");
const pageIsHttps = isBrowser && window.location.protocol === "https:";
const defaultApiUrl = isLocalBrowser ? LOCAL_API_URL : PRODUCTION_API_URL;
const shouldUseConfiguredApiUrl =
  configuredApiUrl &&
  (isLocalBrowser || !configuredApiUrlIsLocal) &&
  !(pageIsHttps && configuredApiUrlIsInsecure);
const apiBaseUrl = trimTrailingSlash(
  shouldUseConfiguredApiUrl
    ? configuredApiUrl
    : defaultApiUrl
);

export default apiBaseUrl;
